import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { FeeTabs } from 'src/app/models/fees';

@Component({
  selector: 'fees-tabs',
  templateUrl: './fees-tabs.component.html',
  styleUrls: ['./fees-tabs.component.scss']
})
export class FeesTabsComponent implements OnInit, OnDestroy {
static readonly TAB_QUERY_PARAM = 'tab';

  @Output() change = new EventEmitter<FeeTabs>();
  routeParamSubscription: Subscription;

  FeeTabs = FeeTabs;
  selectedTab: FeeTabs;

  constructor(
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit() {
    this._setSelectedTab();
  }

  ngOnDestroy() {
    this.routeParamSubscription?.unsubscribe();
  }

  private _setSelectedTab() {
    this.routeParamSubscription = this.route.paramMap.subscribe(params => {
      const tab = params.get(FeesTabsComponent.TAB_QUERY_PARAM) as FeeTabs;

      if (Object.values(FeeTabs).includes(tab)) {
        this.selectedTab = tab;
      } else {
        this.router.navigate(['/page', 'fees', 'fiat'], { queryParamsHandling: 'merge' });
      }

      this.change.emit(this.selectedTab);
    });
  }

  selectMenuItem(selected: FeeTabs) {
    this.selectedTab = selected;
    this.router.navigate(['/page', 'fees', selected], { queryParamsHandling: 'merge' });
  }
}
